import { render, staticRenderFns } from "./addOrEditor.vue?vue&type=template&id=59072d8e&scoped=true"
import script from "./addOrEditor.vue?vue&type=script&lang=js"
export * from "./addOrEditor.vue?vue&type=script&lang=js"
import style0 from "./addOrEditor.vue?vue&type=style&index=0&id=59072d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59072d8e",
  null
  
)

export default component.exports